import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { CACHE_TTL } from './config/queryConfig';
import { ModeAffichageProvider } from './theme/ModeAffichage';

// Configure React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: CACHE_TTL.DYNAMIC,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ModeAffichageProvider>
          <CssBaseline />
          <App />
        </ModeAffichageProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);